<template>
  <div id="app">
    <link
      href="https://fonts.googleapis.com/icon?family=Material+Icons"
      rel="stylesheet"
    />
    <router-view></router-view>
  </div>
</template>
<script>
import liff from "@line/liff";
//import axios from "axios";
export default {
  name: "app",
  data() {
    return {
      profile: {},
      lineInfo: {},
      redirectTo: "",
    };
  },

  computed:{
    
  },

  methods:{
    getMembers(){
    console.log("line info watching");
        //if (val.userId && !this.profile._id) {
          //
          //console.log("checkExisted");
         this.$store.dispatch("checkExistedMember", {
            line_id: localStorage.getItem("line_id"),
            custId: localStorage.getItem("custId"),
            apiKey: localStorage.getItem("apiKey"),
          });

          
        //}
      }
  },
  mounted(){
     console.log("APP mounted");
     console.log(this.$route);
    /*
      if(this.$route.params.liffId || this.$route.query.liffId){
          this.$router.push({
              path: "Auth",
              querry: this.$route.params.liffId || this.$route.query.liffId
            
            })
        }
      */
      this.$store.dispatch("getCustInfoByDomain", {
      //domain: "loyalty.loyaltyhub.me",
      });

      if (this.$route.params.liffId || this.$route.query.liffId) {
        let  liffId = this.$route.params.liffId || this.$route.query.liffId
        liff
          .init({ liffId: liffId })
          .then( ()=> {
            liff
              .getProfile()
              .then((profile) => {
                localStorage.setItem("liffId", liffId);
                console.log('SET PROFILE');
                localStorage.setItem("line_id", profile.userId);
                localStorage.setItem("line_email", liff.getDecodedIDToken().email);
                localStorage.setItem("line_name", profile.displayName);
                localStorage.setItem("line_img", profile.pictureUrl);
                profile.email = liff.getDecodedIDToken().email;

                this.$store.dispatch("setLineProfile", profile);

          })
        })// end then init
        //alert(JSON.stringify(this.$store.state.lineInfo))
        /*
        this.$router.push({
          path: "Auth",
          query: this.$route.params.liffId || this.$route.query.liffId,
        });
        */
      }
    },

   
  }
</script>
<style>
@import "./Css/style.css";

</style>
